import React, { useCallback, useMemo, useState } from 'react';
import { UIProviderContext } from './context';

export const SIDEBAR_COLLAPSED_STORAGE_KEY = 'alux-admin:sidebar-collapsed';

const readCollapsedState = () => {
  try {
    return localStorage.getItem(SIDEBAR_COLLAPSED_STORAGE_KEY) === 'true';
  } catch (e) {
    return false;
  }
};

const UIProvider = ({ children }: { children: React.ReactNode }) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState<boolean>(readCollapsedState);

  const toggleSidebarCollapsed = useCallback(() => {
    setIsSidebarCollapsed((prev) => {
      const next = !prev;
      try {
        localStorage.setItem(SIDEBAR_COLLAPSED_STORAGE_KEY, next ? 'true' : 'false');
      } catch (e) {
        // Storage may be unavailable: the state still works for this session.
      }
      return next;
    });
  }, []);

  const value = useMemo(
    () => ({
      isModalOpen,
      setIsModalOpen,
      isSidebarCollapsed,
      toggleSidebarCollapsed,
    }),
    [isModalOpen, isSidebarCollapsed, toggleSidebarCollapsed],
  );

  return <UIProviderContext.Provider value={value}>{children}</UIProviderContext.Provider>;
};

export default UIProvider;
